import { CSSParsedDeclaration } from '../css/index';
import { TextContainer } from './text-container';
import { Bounds, parseBounds } from '../css/layout/bounds';
import { isHTMLElementNode } from './node-parser';
import { Context } from '../core/context';
import { DebuggerType, isDebugging } from '../core/debugger';

export const enum FLAGS {
    CREATES_STACKING_CONTEXT = 1 << 1,
    CREATES_REAL_STACKING_CONTEXT = 1 << 2,
    IS_LIST_OWNER = 1 << 3,
    DEBUG_RENDER = 1 << 4
}

export class ElementContainer {
    readonly styles: CSSParsedDeclaration;
    readonly textNodes: TextContainer[] = [];
    readonly elements: ElementContainer[] = [];
    bounds: Bounds;
    flags = 0;

    constructor(protected readonly context: Context, element: Element) {
        if (isDebugging(element, DebuggerType.PARSE)) {
            debugger;
        }
        const elementStyle = { ...window.getComputedStyle(element, null) }
        if (this.isBackgroundClip(elementStyle)) {
            elementStyle.backgroundColor = 'transparent'
            elementStyle.backgroundImage = 'none'
        }
        this.styles = new CSSParsedDeclaration(context, elementStyle);

        if (isHTMLElementNode(element)) {
            if (this.styles.animationDuration.some((duration) => duration > 0)) {
                element.style.animationDuration = '0s';
            }

            if (this.styles.transform !== null) {
                // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
        }

        this.bounds = parseBounds(this.context, element);

        if (isDebugging(element, DebuggerType.RENDER)) {
            this.flags |= FLAGS.DEBUG_RENDER;
        }
    }
    isBackgroundClip(style: CSSStyleDeclaration): boolean {
        const isHave = style.webkitBackgroundClip === 'text' || style.backgroundClip === 'text'
        return isHave && (CSS.supports('-webkit-background-clip', 'text') || CSS.supports('background-clip', 'text'))
    }
}
